import CategoryList from './List';
import CategoryForm from './Form';


export default {
    path: 'cadastros',
    redirect: '/cadastros/categorias',
    name: 'Cadastro Categorias',
    component: {
        render(c) {
            return c('router-view')
        }
    },
    children: [
        {
            path: 'categorias',
            name: 'list-category',
            component: CategoryList,
            meta: {
                requiresAuth: true,
                label: 'Listar Categorias'
            }
        },
        {
            path: 'categorias/novo',
            name: 'new-category',
            component: CategoryForm,
            meta: {
                requiresAuth: true,
                label: 'Adicionar Categoria'
            }
        },
        {
            path: 'categorias/:id',
            name: 'edit-category',
            component: CategoryForm,
            meta: {
                requiresAuth: true,
                label: 'Editar Categoria'
            }
        },

    ]
}



// WEBPACK FOOTER //
// ./src/views/category/router.js